<template>
    <div  class="casestudiesitemmobile"  >
        
        <div class="slideshow-container">

          <div class="mySlides fade">
            <!--<div class="numbertext">1 / 4</div>-->
            <img :src="defaultimagesrc" style="width:100%">
            <!--<div class="text">Caption Text</div>-->
          </div>

          <div class="mySlides fade">
            <!--<div class="numbertext">2 / 4</div>-->
            <img :src="image1src" style="width:100%">
            <!--<div class="text">Caption Two</div>-->
          </div>

          <div class="mySlides fade">
            <!--<div class="numbertext">3 / 4</div>-->
            <img :src="image2src" style="width:100%">
            <!--<div class="text">Caption Three</div>-->
          </div>

          <div class="mySlides fade">
            <!--<div class="numbertext">4 / 4</div>-->
            <img :src="image3src" style="width:100%">
            <!--<div class="text">Caption Three</div>-->
          </div>

          <!-- Next and previous buttons -->
          <a v-if="caseitemmobile.images.length>1" class="prev" @click="fnPlusSlides(-1)">&#10094;</a>
          <a v-if="caseitemmobile.images.length>1" class="next" @click="fnPlusSlides(1)">&#10095;</a>
        </div>
        <div class="disclaimer">{{disclaimerlabel}}</div>
        <br>

        <!-- The dots/circles -->
        <div style="text-align:center">
          <span v-if="caseitemmobile.defaultimage!=''" class="dot" @click="fnCurrentSlide(1)"></span>
          <span v-if="caseitemmobile.image1!=''" class="dot" @click="fnCurrentSlide(2)"></span>
          <span v-if="caseitemmobile.image2!=''" class="dot" @click="fnCurrentSlide(3)"></span>
          <span v-if="caseitemmobile.image3!=''" class="dot" @click="fnCurrentSlide(4)"></span>
        </div>



        <div class="title_casestudiesitemmobile">{{caseitemmobile.title}}</div>
        <div class="divisore_casestudiesitemmobile"></div>
        <div class="company_casestudiesitemmobile">{{caseitemmobile.company}}</div>
        <div class="divisore_casestudiesitemmobile"></div>
        <div class="year_casestudiesitemmobile">{{caseitemmobile.year}}</div>
        <div class="divisore_casestudiesitemmobile"></div>
        <div class="tags_casestudiesitemmobile">
          <span  v-for="tag in caseitemmobile.tags" :key="tag">{{tag}}</span>
        </div>
        <div class="divisore_casestudiesitemmobile"></div>
        <div class="description_casestudiesitemmobile">{{caseitemmobile.description}}</div>
        
        <div class="url_casestudiesitemmobile" v-if="caseitemmobile.url!=''" >
      
            <a v-if="caseitemmobile.url!='' && isyoutube==true" target="_blank"  :href="caseitemmobile.url">{{youtubelabel}}</a> 
            <a v-if="caseitemmobile.url!='' && isyoutube==false" target="_blank"  :href="caseitemmobile.url">{{caseitemmobile.url}}</a> 
          
        </div>


        <div @click="fnBack" class="backlinkmobile"> 
                <img src="@/assets/images/arrow_left.svg" /><br/><b>{{backlabel}}</b>
        </div>
    </div>
 
</template>

<script>
import backendmixin from '../mixins/backendmixin.js';
import multilangmixin from "../mixins/multilangmixin.js"
// eslint-disable-next-line no-unused-vars

export default {
  
  name: "cmpcasestudiesmobile",
  mixins:[multilangmixin,backendmixin],
  props:["caseitemmobile"],
    

  data(){
      return {
                "slideindex":1
            };
  },

  created(){
    //console.log("created ",this.$options.name, "   lingua: ",this.currentlang);

    //this.fnShowSlides(this.slideindex);
  },
 
  mounted(){
    
    this.fnShowSlides(this.slideindex);
  },

  computed:{

     isyoutube(){
        if (this.caseitemmobile.url.search("youtu") >=0) 
        {
            return true;
        }
        else
        {
          return false;
        }
      },

      defaultimagesrc(){
        return this.fnGetImageUrl(this.caseitemmobile.defaultimage);
      },

      image1src(){
      if (this.caseitemmobile.image1=="")
      {
        return "";
      }
      else
      {
        return this.fnGetImageUrl(this.caseitemmobile.image1);
      }
    },

     image2src(){
      if (this.caseitemmobile.image2=="")
      {
        return "";
      }
      else
      {
        return this.fnGetImageUrl(this.caseitemmobile.image2);
      }
    },

    image3src(){
      if (this.caseitemmobile.image3=="")
      {
        return "";
      }
      else
      {
        return this.fnGetImageUrl(this.caseitemmobile.image3);
      }
    },


    disclaimerlabel()
      {
        return this.fnGetTranslation(this.currentlang, "disclaimer");
      },
      youtubelabel()
      {
        return this.fnGetTranslation(this.currentlang, "youtube");
      },


      keyurl(){
        return "/"+this.currentlang+"/caseitem?key="+this.caseitemmobile.key;
      },  
      backlabel()
      {
        return this.fnGetTranslation(this.currentlang, "back");
      },
  },


  methods:{

      fnBack(){
        this.$router.go(-1);
      },


      fnPlusSlides(n) 
      {
        this.fnShowSlides(this.slideindex += n);
      },

      // Thumbnail image controls
      fnCurrentSlide(n) 
      {
        this.fnShowSlides(this.slideindex = n);
      },

      fnShowSlides(n) 
      {
        let i;
        let wslides = document.getElementsByClassName("mySlides");
        let wdots = document.getElementsByClassName("dot");
        if (n > wslides.length) 
        {
          this.slideindex = 1;
        }
        if (n < 1) 
        {
          this.slideindex = wslides.length;
        }

        for (i = 0; i < wslides.length; i++) 
        {
          wslides[i].style.display = "none";
        }

        for (i = 0; i < wdots.length; i++) 
        {
          wdots[i].className = wdots[i].className.replace(" active", "");
        }

        wslides[this.slideindex-1].style.display = "block";
        wdots[this.slideindex-1].className += " active";

      }

  /*
  //slideshow automatico
function showSlides() {
  var i;
  var slides = document.getElementsByClassName("mySlides");
  for (i = 0; i < slides.length; i++) {
    slides[i].style.display = "none";
  }
  slideIndex++;
  if (slideIndex > slides.length) {slideIndex = 1}
  slides[slideIndex-1].style.display = "block";
  setTimeout(showSlides, 2000); // Change image every 2 seconds
}

  */



  }

  

}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    
    .casestudiesitemmobile div img
  {
    width: 100%;
  }


  .title_casestudiesitemmobile{
    margin-top: 2vh;
    font-size: 1em;
    font-weight: bold;
  }

  .company_casestudiesitemmobile{
    margin-top: 0.4vh;
    font-size: 1em;
    font-weight: 400;
  }

  .year_casestudiesitemmobile{
    margin-top: 0.4vh;
    font-size: 1em;
    font-weight: 400;
  }

  .tags_casestudiesitemmobile
  {
    margin-top: 0.4vh;
    font-size: 0.8em;
    font-weight: 400;
  }

  .tags_casestudiesitemmobile span
  {
    margin-right: 0.5vh;
    /*background-color: #e6e4e4;*/
    background-color: #ffdd00;
    
  }


  .divisore_casestudiesitemmobile{
    margin-top: 0.5em;
    margin-bottom: 0.5em;
    background-color: black;
    width: 18px;    
    height: 2px;    
  }



  .description_casestudiesitemmobile{
    margin-top: 0.4vh;
    font-size: 0.8em;
    font-weight: 400;
  }

  .url_casestudiesitemmobile{
    margin-top: 2vh;
    font-size: 0.8em;
    font-weight: 400;
  }


  .url_casestudiesitemmobile a 
  {
    color: black; 
    text-decoration: none;
  }

  .url_casestudiesitemmobile  a:visited{
    color: black;
    text-decoration: none;
  }

  .url_casestudiesitemmobile a:active{
    color: black;
    text-decoration: none;
  }

  .url_casestudiesitemmobile a:hover{

  color: #ffdd00;
  font-weight: bold;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-color: white;
  text-decoration-thickness: 0.3em;
  }




  .backlinkmobile{
    font-size: 0.8em;
    margin-top: 80px;
  }

  .backlinkmobile img{
    transform: rotate(180deg);
    width: 20%;
    max-width: 50px;
    cursor: pointer;
  }
  

/*
  .debug1
  {
    background-color: aquamarine;
  }

  .debug2
  {
    background-color: red;
  }

*/


  * {box-sizing:border-box}

  /* Slideshow container */
  .slideshow-container {
    max-width: 1000px;
    position: relative;
    margin: auto;
  }

  /* Hide the images by default */
  .mySlides {
    display: none;
  }

  /* Next & previous buttons */
  .prev, .next {
    cursor: pointer;
    position: absolute;
    top: 50%;
    width: auto;
    margin-top: -22px;
    padding: 16px;
    color: white;
    font-weight: bold;
    font-size: 18px;
    transition: 0.6s ease;
    border-radius: 0 3px 3px 0;
    user-select: none;
  }

  /* Position the "next button" to the right */
  .next {
    right: 0;
    border-radius: 3px 0 0 3px;
  }

  /* On hover, add a black background color with a little bit see-through */
  .prev:hover, .next:hover {
    background-color: rgba(0,0,0,0.8);
  }

  /* Caption text */
  .text {
    color: #f2f2f2;
    font-size: 15px;
    padding: 8px 12px;
    position: absolute;
    bottom: 8px;
    width: 100%;
    text-align: center;
  }

  /* Number text (1/3 etc) */
  .numbertext {
    color: #f2f2f2;
    font-size: 12px;
    padding: 8px 12px;
    position: absolute;
    top: 0;
  }

  /* The dots/bullets/indicators */
  .dot {
    cursor: pointer;
    height: 15px;
    width: 15px;
    margin: 0 2px;
    background-color: #bbb;
    border-radius: 50%;
    display: inline-block;
    transition: background-color 0.6s ease;
  }

  .active, .dot:hover {
    background-color: #717171;
  }

  /* Fading animation */
  .fade {
    -webkit-animation-name: fade;
    -webkit-animation-duration: 1.5s;
    animation-name: fade;
    animation-duration: 1.5s;
  }

  @-webkit-keyframes fade {
    from {opacity: .4}
    to {opacity: 1}
  }

  @keyframes fade {
    from {opacity: .4}
    to {opacity: 1}
  }


























  @media screen and (min-width: 700px)    {
      /*  schermo desktop */
    
    .casestudiesitemmobile{
        width: 270px;
     
    }

  }
  
  @media screen and (max-width: 700px) {
     /*  schermo mobile */
    
    .casestudiesitemmobile{
        
        margin-bottom: 2em;
        padding: 7vw;

    }
 
  }


</style>
